import { useState, useRef, useEffect } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  Tabs,
  Tab,
  IconButton,
  Grid,
  Rating,
} from "@mui/material";
import BookmarkBorderIcon from "@mui/icons-material/BookmarkBorder";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import parse from "html-react-parser";
const gradlynk_API_ENDPOINT = process.env.REACT_APP_API_SAP;

export default function Testimonials() {
  const [loading, setLoading] = useState(true);
  const scrollRef = useRef(null);
  const [cardData, setCardData] = useState([]);
  const [isAtStart, setIsAtStart] = useState(true);
  const [isAtEnd, setIsAtEnd] = useState(false);

  // Scroll functions
  const scrollLeft = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: -300, behavior: "smooth" });
    }
  };

  const scrollRight = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: 300, behavior: "smooth" });
    }
  };

  const fetchData = async () => {
    try {
      const response = await fetch(`${gradlynk_API_ENDPOINT}get-testimonials`, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      });

      if (response.ok) {
        const data = await response.json();
        setCardData(data?.data || []);
        setLoading(false);
      } else {
        console.error("Internal server error");
        setLoading(false);
      }
    } catch (err) {
      console.error("Internal server error", err);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  // Check scroll position to enable/disable buttons
  const handleScroll = () => {
    const el = scrollRef.current;
    if (!el) return;

    setIsAtStart(el.scrollLeft <= 0);
    setIsAtEnd(el.scrollLeft + el.clientWidth >= el.scrollWidth - 1);
  };

  // Update scroll buttons status on scroll and when data changes
  useEffect(() => {
    const el = scrollRef.current;
    if (el) {
      handleScroll(); // initial check
      el.addEventListener("scroll", handleScroll);
      return () => el.removeEventListener("scroll", handleScroll);
    }
  }, [cardData]);

  return (
    <Grid container>
      <Grid item xs={12}>
        <Typography
          fontSize="22px"
          color="#000000"
          fontFamily="Inter"
          fontWeight={400}
        >
          What Our Students Say
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Grid
          container
          justifyContent="center"
          sx={{
            borderRadius: "20px",

            position: "relative",

            // width: "730px",
            width: "100%",
            maxWidth: "100%",
          }}
        >
          {/* Left Nav Button */}
          <IconButton
            disabled={isAtStart}
            onClick={() => {
              scrollLeft();
            }}
            sx={{
              position: "absolute",
              top: "50%",
              left: 12,
              transform: "translateY(-50%)",
              bgcolor: "#fff",
              boxShadow: "0px 2px 6px rgba(0,0,0,0.15)",
              opacity: isAtStart ? 0.5 : 1,
              "&:hover": { bgcolor: "#f2f2f2" },
            }}
          >
            <ArrowBackIosNewIcon
              fontSize="small"
              color="#000000"
              style={{ color: "#000000" }}
            />
          </IconButton>

          {/* Right Nav Button */}
          <IconButton
            disabled={isAtEnd}
            onClick={() => {
              scrollRight();
            }}
            sx={{
              position: "absolute",
              top: "50%",
              right: 10,
              transform: "translateY(-50%)",
              bgcolor: "#fff",
              boxShadow: "0px 2px 6px rgba(0,0,0,0.15)",
              opacity: isAtEnd ? 0.5 : 1,
              "&:hover": { bgcolor: "#f2f2f2" },
            }}
          >
            <ArrowForwardIosIcon
              fontSize="small"
              color="#000000"
              style={{ color: "#000000" }}
            />
          </IconButton>

          {/* Cards Row - scrollable slider */}
          <Box
            ref={scrollRef}
            mt={1}
            sx={{
              px: { xs: 1, sm: 2 },
              borderRadius: "16px",
              display: "flex",
              gap: 4,
              overflowX: "auto",
              scrollBehavior: "smooth",
              "&::-webkit-scrollbar": { display: "none" },
              maxWidth: {
                xs: "100%",
                sm: "100%",
                md: "960px",
                lg: "1024px",
                xl: "1200px",
              },
              padding: "10px",
            }}
          >
            {/* Group every 2 cards into a vertical column */}
            {cardData?.map((data, index) => (
              <Card
                key={index}
                sx={{
                  display: "flex",
                  flexDirection: "column", // make vertical stack
                  justifyContent: "space-between", // push content and button apart
                  borderRadius: "12px",
                  border: "1px solid #F9FAFB",
                  borderRadius: "12px",

                  width: {
                    xs: "260px",
                    sm: "300px",
                    md: "360px",
                    lg: "480px",
                    xl: "580px",
                  },

                  height: "100%",

                  flexShrink: 0,
                  boxShadow: "0px 2px 6px rgba(0,0,0,0.2)",
                  backgroundColor: "white",
                  padding: 2,
                }}
              >
                <Box sx={{ flex: 1 }}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Typography
                      fontSize="14px"
                      color="#333333"
                      fontFamily="Inter"
                      fontWeight={400}
                    >
                      {data?.comment}
                    </Typography>
                  </Grid>
</Grid>
                  </Box>


<Grid container mt="auto" textAlign="center" pt={2}> 
                  <Grid item xs={12} sm={12} md={6} textAlign="left">
                    <Typography
                      fontSize="16px"
                      color="#9D0385"
                      fontFamily="Inter"
                      fontWeight={400}
                    >
                      ~ {data?.name}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={12} md={6} textAlign="end">
                    <Rating
                      name="half-rating"
                      value={data.rating || 4}
                      readOnly
                    />
                  </Grid>
              </Grid>
              </Card>
            ))}
          </Box>
        </Grid>
      </Grid>
    </Grid>
  );
}
